var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-primary my-2",attrs:{"id":"busybox"}},[_c('b-spinner',{staticClass:"align-middle mr-3"}),_c('strong',[_vm._v("Cargando...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }